// const dict = {
export default {
    state: {
        dictScene: '101',// 场景类别
        dictProductType: '102',// 产品类别
        dictAppType: '102',// 应用类型
        dictAppLabel: '103',// 应用标签
        dictAppCatalog: '104',// 应用分类
        baseDictCountry: '102',// 公共字典——国别
        baseDictCategory: '103',// 公共字典——类别
        baseDictSchoolType: '325'// 公共字典——学校类别
    },
    mutations: {},
    actions: {}
};

// export default dict;